
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 234 62"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M188.917.941h10.045C223.578.941 234 14.317 234 31.051c0 16.733-10.422 30.11-35.038 30.11h-10.045V.94zm-7.513 60.22h-52.597c1.5-18.57 12.62-26.347 26.298-26.347 13.678 0 24.8 7.777 26.299 26.346zm-11.74-46.576c0 8.054-6.519 14.584-14.559 14.584s-14.558-6.53-14.558-14.584C140.547 6.53 147.065 0 155.105 0s14.558 6.53 14.558 14.585zM28.49 48.674l-16.698-24.95V61.15H0V3.12h11.227l17.547 27.407L46.227 3.12h11.038v58.03H45.378V23.724l-16.51 24.95h-.377zM79.533 61.15H67.835V18.902h11.698V61.15zM92.27 28.354h-6.415v-9.451h6.415V7.467h11.604v11.436h9.245v9.451h-9.245v18.524c0 3.308 1.792 4.82 4.811 4.82 1.793 0 3.774-.566 5.095-1.417v10.396c-1.605.851-4.435 1.323-7.548 1.323-8.585 0-13.962-4.253-13.962-13.61V28.354zM80.618 6.947c0 3.837-3.104 6.947-6.934 6.947s-6.934-3.11-6.934-6.947S69.854 0 73.684 0s6.934 3.11 6.934 6.947z","fill":"#0060E6","fill-rule":"evenodd"}})])
          )
        }
      }
    